module.exports = __webpack_public_path__ + "img/eight2Red.fb7ee2d6.jpg";